// -----------------------------------------------------------------------------
// Scripts for schedule
// -----------------------------------------------------------------------------

$(function () {
  const scheduleGrid = $('.schedule');

  $.each( scheduleGrid, function() {
    const scheduleGridCols = $(this).attr('data-col');
    const scheduleTimeRows = $(this).find('.time');
    let areasEvents = "";
    let areaTimes = [];
    let areas = [];

    $.each( scheduleTimeRows, function() {
      const timeStart = $(this).attr('data-time');
  
      areaTimes.push(`time${timeStart}`);
    });
  
    for(let i = 0; i < scheduleGridCols; i++) {
      areasEvents += " event";
    }
  
    for(let i = 0; i < areaTimes.length; i++) {
      const currentArea = areaTimes[i];
  
      currentArea += areasEvents;
      areas.push(currentArea);
    }
  
    $(this).css('grid-template-areas', `"${areas.join('"\n"')}"`);
  });

  $('.section-agenda__tabs').fadeIn('slow');
});